import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { NavLink } from 'react-router-dom'
import {
  X,
  LayoutDashboard,
  Settings,
  CreditCard,
  Network,
  Brain,
  FlaskConical
} from 'lucide-react'
import Logo from '../Common/Logo'

const MobileNav = ({ isOpen, onClose }) => {
  const navItems = [
    { name: 'Dashboard', href: '/app', icon: LayoutDashboard },
    { name: 'Integrations', href: '/app/integrations', icon: Network },
    { name: 'AI Optimization', href: '/app/ai-optimization', icon: Brain },
    { name: 'A/B Testing', href: '/app/ab-testing', icon: FlaskConical },
    { name: 'Settings', href: '/app/settings', icon: Settings },
    { name: 'Billing', href: '/app/billing', icon: CreditCard },
  ]

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 z-40 bg-black bg-opacity-25 lg:hidden"
          />

          {/* Mobile Navigation */}
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-xl lg:hidden"
          >
            <div className="flex flex-col h-full">
              {/* Header */}
              <div className="flex items-center justify-between p-4 border-b border-secondary-200">
                <Logo />
                <button
                  onClick={onClose}
                  className="p-2 rounded-lg text-secondary-500 hover:text-secondary-700 hover:bg-secondary-100 transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {/* Navigation */}
              <nav className="flex-1 p-4 space-y-2">
                {navItems.map((item) => {
                  const Icon = item.icon
                  return (
                    <NavLink
                      key={item.name}
                      to={item.href}
                      onClick={onClose}
                      className={({ isActive }) =>
                        `flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                          isActive
                            ? 'bg-primary-50 text-primary-700 border-r-2 border-primary-600'
                            : 'text-secondary-600 hover:text-secondary-900 hover:bg-secondary-50'
                        }`
                      }
                    >
                      <Icon className="w-5 h-5" />
                      <span>{item.name}</span>
                    </NavLink>
                  )
                })}
              </nav>

              {/* Footer */}
              <div className="p-4 border-t border-secondary-200">
                <div className="text-xs text-secondary-500 text-center">
                  Triage Genius v1.0.0
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default MobileNav